import { Heading, Text, Divider, List, Paragraph, Box, Anchor, Button } from 'dracula-ui'; 
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// TODO: maybe find a way to generalise data fields ...

function createWorkTab(data) {
  return(
    data.map((item, index) => {
      var divider;
      // Don't show divider for latest element
      if (index < data.length - 1) {
        divider = <Divider />;
      } else {
        divider = null;
      }
      return(
        <div key={index}>
          <Heading>{item.position}</Heading>
          <Text>{item.compagny}</Text>
          <br></br>
          <Text>{item.startDate + '/' + item.endDate}</Text>
          <List variant="unordered">
            {item.highlights.map((item, index) => (
              <li 
                key={index} 
                className="drac-text drac-text-white">
                <Text size="xs">{item}</Text>
              </li>
            ))}
          </List>
          {divider}
        </div>
      )
    })
  )
}

function createEducationTab(data) {
  return(
    data.map((item, index) => {
      var memoryTitle, description, advisors, divider;
      if (item.memoryTitle) {
        memoryTitle = <Paragraph size="xs">
          <span class="underline">Memory title</span>{': ' + item.memoryTitle}
        </Paragraph>;
      }
      if (item.description) {
        description = <Paragraph size="xs">
          <span class="underline">Description</span>{': ' + item.description}
        </Paragraph>;
      }
      if (item.advisors) {
        advisors = <Paragraph size="xs">
          <span class="underline">Advisors</span>{': ' + item.advisors}
        </Paragraph>;
      }
      // Don't show divider for latest element
      if (index < data.length - 1) {
        divider = <Divider />;
      } else {
        divider = null;
      }
      return(
        <div key={index}>
          <Heading>{item.studyType}</Heading>
          <Text>{item.institution}</Text>
          <br></br>
          <Text>{item.startDate + '-' + item.endDate}</Text>
          {memoryTitle}
          {description}
          {advisors}
          <Paragraph m="sm" variant='subtle' color="white" size="xs">
            <span class="underline">Fields</span>{': ' + item.area}
          </Paragraph>
          {divider}
        </div>
      )
    })
  )
}

function createTalksTab(data) {
  return(
    data.map((item, index) => {
      var slidesContainer, videoContainer, divider;
      if (item.slides) {
        slidesContainer = <Box p="md">
          <iframe title={item.title + '-slides'} src={item.slides} width="100%" height="250px"></iframe>
        </Box>
      }
      if (item.video) {
        videoContainer = <Box p="md">
          <iframe 
            title={item.title + '-video'} 
            src={item.video} 
            width="100%" 
            height="250px"
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowfullscreen
            >
          </iframe>
        </Box>
      }
      // Don't show divider for latest element
      if (index < data.length - 1) {
        divider = <Divider />;
      } else {
        divider = null;
      }
      return(
        <div key={index}>
          <Heading>{item.event}</Heading>
          <Text>{item.title}</Text>
          <br></br>
          <Text>{item.date}</Text>
          {slidesContainer}
          {videoContainer}
          <List variant="unordered">
            {item.links.map((item, index) => (
              <li 
                key={index} 
                className="drac-text drac-text-white">
                <Text size="xs">{item}</Text>
              </li>
            ))}
          </List>
          {divider}
        </div>
      )
    })
  )
}

function createProjectsTab(data) {
    return(
      data.map((item, index) => {
        var highlights, imageTag, divider;
        if (item.highlights.length > 0) {
          highlights = <List variant="unordered">
            {item.highlights.map((item, index) => (
              <li 
                key={index} 
                className="drac-text drac-text-white">
                <Text size="xs">{item}</Text>
              </li>
            ))}
          </List>
        }
        if (item.image) {
          imageTag = <img src={item.image} alt={item.name + '-image'} width="30%"/>;
        }
        
        // Don't show divider for latest element
        if (index < data.length - 1) {
          divider = <Divider />;
        } else {
          divider = null;
        }

        return(
          <div key={index}>
            <Container>
              <Row>
                <Col><Heading align="center">{item.name}</Heading></Col>
                <Col>{imageTag}</Col>
              </Row>
            </Container>
            <Text size="xs">{'Type: ' + item.type + ', '}</Text>
            <Text size="xs">{item.startDate + '/' + item.endDate + ', '}</Text>
            <Text size="xs">{'Role: ' + item.roles}</Text>
            <Paragraph>{item.description}</Paragraph>
            {highlights}
            <Container>
              <Row>
                <Button className='drac-btn-outline drac-border-white drac-text-white drac-rounded' m="sm">
                  <Anchor href={item.url}>Code</Anchor>
                </Button>
              </Row>
            </Container>
           {divider} 
          </div>
        )
      })
    )
  }

export { createWorkTab, createEducationTab,  createTalksTab, createProjectsTab };